<template>
    <div id="woAccountingTransactions">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>

        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> Work Order Accounting Transactions</div>
                    <div class="web-action-btn btn-groups text-right">
                    <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportReports()">
                        <i class="fp-export"></i> Export
                    </a>
                </div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content customer-ar-report">
                        <data-table-filter-config :moduleName="'workOrderAccountingTransactions'" :allowSameFilter="'allow'"></data-table-filter-config>
                        <div class="data-table bg-white overflow-hidden">
                          <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
                          <section class="data-table bg-white">
                                  <custom-pagination
                                      :page-changed="onPageChange"
                                      :per-page-changed="onPerPageChange" :moduleName="'workOrderAccountingTransactions'" :position="'top'">
                                  </custom-pagination>
                                  <vue-good-table
                                      ref="WorkOrderAccountingTransactions"
                                      mode="remote"
                                      title="Work Order Accounting Transactions"
                                      @on-page-change="onPageChange"
                                      @on-column-filter="onColumnFilter"
                                      @on-per-page-change="onPerPageChange"
                                      @on-sort-change="onSortChange"
                                      :totalRows="totalRecords"
                                      :columns="userColumns"
                                      :rows="rows"
                                      :pagination-options="{
                                          enabled: false,
                                          position: 'both',
                                          perPage: perPage,
                                          perPageDropdown:dropDownPerPage,
                                          dropdownAllowAll: false,
                                      }"

                                      :search-options="{
                                      enabled: false,
                                      }">
                                  </vue-good-table>
                                  <custom-pagination
                                      :page-changed="onPageChange"
                                      :per-page-changed="onPerPageChange">
                                  </custom-pagination>
                          </section>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import {commonMixins} from '../../mixins/commonMixins';
import {dataTableMixins} from '../../mixins/dataTableMixins';
export default {
    name: "WorkOrderAccountingTransactions",
    metaInfo() {
        return {
            title: "Work Order Accounting Transactions | " +process.env.COPYRIGHT_NAME
        }
    },
    mixins:[commonMixins,dataTableMixins],
    data: () => ({
        firstLoad: 0,
        permissions: [],
        cantAccessPage: "",
        userColumns:[],
        columns: [
            {
                label:'Work Order Number',
                field:'work_order_no',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
            },
            {
                label:'Parent Work Order',
                field:'parent_work_order',
                fpFieldType:"text",
                filterable: false,
                hidden:false,
                sortable: false,
            },
            {
                label: "WO Open Date",
                field: "open_date",
                hidden:false,
                fpFieldType:"date",
                filterable: true,
            },
            {
                label: "WO Closed Date",
                field: "close_date",
                hidden:false,
                fpFieldType:"date",
                filterable: true,
            },
            {
                label: "Work Order Status",
                field: "wo_status",
                fpFieldType:"option",
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "All", // placeholder for filter input
                    filterDropdownItems: ['Open','In Progress' ,'Review', 'Closed','Approved'],
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label:'Facility ID Code',
                field:'location',
                fpFieldType:"option",
                filterable: true,
                hidden:false,
            },
            {
                label:'Unit Number',
                field:'unit_no',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
            },
            {
                label:'Sequence Number',
                field:'seq_no',
                fpFieldType:"text",
                filterable: false,
                hidden:false,
                sortable:false,
            },
            {
                label:'Source Document Type',
                field:'doc_type',
                fpFieldType:"text",
                filterable: false,
                hidden:false,
                sortable:false,
            },
            {
                label:'Work Order Trans Type',
                field:'wo_trans_type',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
            },
            {
                label:'Source Document Number',
                field:'source_doc_number',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
            },
            {
                label:'Accounting Trans Type',
                field:'accounting_trans_type',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
            },
            {
                label:'Accounting Trans Number',
                field:'ac_trans_no',
                fpFieldType:"text",
                filterable: false,
                hidden:false,
                sortable:false,
            },
            {
                label:'Transaction Status',
                field:'trans_sts',
                fpFieldType:"text",
                filterable: false,
                hidden:false,
                sortable:false,
            },
            {
                label: "Date Created",
                field: "issued_at",
                hidden:false,
                fpFieldType:"date",
                filterable: true,
            },
            {
                label:'User ID Create',
                field:'user_added',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
            },
            {
                label:'Company',
                field:'company',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
            },
            {
                label:'GL Source',
                field:'source',
                fpFieldType:"option",
                filterable: true,
                hidden:false,
            },
            {
                label:'GL Transaction AST',
                field:'trans_ast',
                fpFieldType:"text",
                filterable: false,
                hidden:false,
                sortable:false,
            },
            {
                label:'GL Period',
                field:'gl_period',
                fpFieldType:"integer",
                type:'number',
                filterable: true,
                hidden:false,
            },
            {
                label:'GL Year',
                field:'gl_year',
                fpFieldType:"integer",
                type:'number',
                filterable: true,
                hidden:false,
            },
            {
                label:'GL Account',
                field:'gl_account',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
            },
            {
                label:'GL Account Description',
                field:'gl_acct_desc',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
            },
             {
                label:'GL Transaction Amount',
                field:'amount',
                fpFieldType:"integer",
                filterable: true,
                hidden:false,
                type:'number',
            },
            {
                label:'GL Account Type',
                field:'account_type',
                fpFieldType:"option",
                filterable: true,
                hidden:false,
            },
        ],
        rows: [],
        totalRecords: 0,
        loading:false,
        action:'list',
        batchProcess:0,
        batchNum:"",
    }),
    watch: {
        //check permission change
        permissions: function (permissions) {
            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'work_order_accounting_transactions_report') {
                        self.cantAccessPage = true;
                    }
                }
            }
        },
    },
    created: function() {
        this.serverParams.stopRequest = true;
    },
    mounted: function() {
        var self = this;

        self.getPermissions();
    },
    methods: {
        // exportReports: function() {
        //     var self = this;
        //     this.action = "export";
        //     this.loadList();
        // },
        loadList: function() {
            var self = this;

            var fields = {
                page: self.serverParams.page,
                perPage: self.serverParams.perPage,
                filters: self.serverParams.columnFilters,
                sort: self.serverParams.sort,
                action:self.action
            };

            self.firstLoad = 1;
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/report/wo-accounting-transaction",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (data.status == "success") {
                        if (self.action == "export" ||  self.action == "export_queue") {

                          if ( data.code == "201" ) {
                              alert(data.message);
                          } else {

                              if ( self.action == "export" ) {

                                  self.excel = data.content.web;
                                  var save = document.createElement("a");
                                  save.href = self.excel;
                                  save.download = data.content.web;
                                  save.target = "_blank";

                                  document.body.appendChild(save);
                                  save.click();
                                  document.body.removeChild(save);

                              } else {

                                  self.batchProcess = 1;
                                  self.batchNum = data.content;
                              }

                          }

                        self.action = "list";
                        // self.loadList();

                        } else {
                          self.rows = data.content.row;
                          self.totalRecords = data.content.totalRecords;
                        }

                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'wo-accounting-transaction')
                }
            });
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/reports/WorkOrderAccountingTransactions.vue